import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCashappComponent } from './simple-icons-cashapp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCashappComponent ],
    exports:      [ SimpleIconsCashappComponent ],
    bootstrap:    []
})
export class SimpleIconsCashappModule {}
